// extracted by mini-css-extract-plugin
export default {"qrBlock":"QrBlock_qrBlock__c5-2N","qr":"QrBlock_qr__FW5BP"};